// ======= Accordion =======

jQuery('.heading-accordion').click(function(){ // Fire the function
    jQuery(this).parent().toggleClass('active'); // Toggle active class on the parent element
});